"use strict";

exports.__esModule = true;
exports["default"] = Checkmark;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Checkmark(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M490.066 145.686L266.682 469.093c-14.312 14.739-32.683 22.483-52.229 22.483-19.759 0-37.596-7.479-51.854-21.629L22.096 320.953C8.583 307.495 1 289.23 1 269.739c-.054-19.572 7.53-37.942 21.309-51.747 13.138-13.352 32.042-21.041 51.802-21.041 19.652 0 38.503 7.609 51.747 20.826l74.337 81.388L385.557 43.577c13.992-14.205 32.31-21.574 52.176-21.574 19.546 0 38.396 7.423 51.748 20.479 13.885 13.913 21.521 32.39 21.521 52.148-.001 19.173-7.478 37.276-20.936 51.056z"
  }));
}